import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface entityState {
  clientEntityId: any;
}

const initialState: entityState = {
  clientEntityId: null
};

const entitySlice = createSlice({
  name: 'entity',
  initialState,
  reducers: {
    setclientEntityIdData: (state, action: PayloadAction<any>) => {
      state.clientEntityId = action.payload;
    }
  }
});

export const { setclientEntityIdData } = entitySlice.actions;
export default entitySlice.reducer;